<template>
  <div class="cascadeResourcePage">
    <cascadePage></cascadePage>
  </div>
</template>

<script>
import cascadePage from "../../../../components/cascadePage/cascadePage";
export default {
  name: "cascadeResource",
  //editForm
  components: {
    cascadePage,
  },
  data() {
    return {

    };
  },
  created() {},
  methods: {
  },
};
</script>

<style scoped lang="less">
.cascadeResourcePage {
  height: 100%;
}
</style>
